module.exports = __webpack_public_path__ + "static/media/Chad Quinn Headshot.1e291617.jpeg";